import ApiService from '../../../../shared/services/ApiService';

export default {
    update(id, data){
        return ApiService.put(`time-options/${id}`, data);
    },

    searchTimezones(query) {
        return ApiService.get(`search-timezone?name=${query}`);
    }
}